type SectionKind = 'prose' | 'list'

interface RecoveryAiTermsSection {
  key: string
  kind: SectionKind
}

// Single source of truth for section order/numbering, shared by
// RecoveryAiTerms.tsx (on-page) and recoveryAiTermsDocument.ts (download) —
// the section number is the array index, so adding/reordering a section here
// changes both outputs together instead of needing two matching edits.
export const RECOVERY_AI_TERMS_SECTIONS: RecoveryAiTermsSection[] = [
  { key: 'pricing', kind: 'prose' },
  { key: 'customer_engagement', kind: 'prose' },
  { key: 'ai_actions', kind: 'list' },
  { key: 'disclaimers', kind: 'list' },
  { key: 'reservation_of_rights', kind: 'prose' },
  { key: 'privacy_and_ai_disclosures', kind: 'list' },
  { key: 'termination', kind: 'list' },
  { key: 'use_restrictions', kind: 'list' },
]

// `I18n`'s missing-translation handler returns undefined rather than a
// string (src/index.js), so a renamed/missing `items` locale key must not
// throw here.
export const asRecoveryAiTermsItems = (items: unknown): string[] => {
  if (Array.isArray(items)) return items
  if (items && typeof items === 'object') return Object.values(items)
  return []
}
